module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"lot":"Lot de {x}"},"en":{"lot":"Set of {x}"},"de":{"lot":"Set aus {x}"},"es":{"lot":"Lote de {x}"},"it":{"lot":"Lotto di {x}"},"nl":{"lot":"Set van {x}"},"pt":{"lot":"Lote de {x}"}}')
  delete Component.options._Ctor
}
